import { useQuery } from '@tanstack/react-query'
import API from '../../utils/api'

export const usePoolView = (poolId) => {
  return useQuery(
    ['pool-view', poolId],
    async () => {
      const { data } = await API.fetchIndividualPool(poolId)
      return data
    }
  )
} 